import type { ConversationDetailAllOf } from './conversationDetailAllOf';
import type { ConversationDetailAllOfThree } from './conversationDetailAllOfThree';

export type ConversationDetail = ConversationDetailAllOf & ConversationDetailAllOfThree;
